import request from "../utils/request";

// 登录
export function login(data) {
    return request({
        method: 'POST',
        data:data,
        url: '/admin/api/login'
    })
}


//菜单列表
export function getMenuData(data){
    return request({
        method:'POST',
        data:data,
        url:'/api/v1/menu/list',
    })
}

//菜单添加
export function menuAdd(data){
    return request({
        method:'POST',
        data:data,
        url:'/api/v1/menu/add',
    })
}

//菜单编辑
export function menuEdit(data){
    return request({
        method:'POST',
        data:data,
        url:'/api/v1/menu/edit',
    })
}

//菜单删除
export function menuDelete(id){
    return request({
        method:'POST',
        data:{ id },
        url:'/api/v1/menu/del',
    })
}

//管理员权限管理
export function adminList(data){
    return request({
        method:'POST',
        data: data,
        url:'/api/v1/permission/list',
    })
}

//管理员状态修改
export function updateAdminStatus(id) {
    return request({
        method: 'POST',
        data: { id },
        url: '/api/v1/permission/change/status',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}


//管理员删除
export function deleteAdmin(id) {
    return request({
        method: 'POST',
        data: { id },
        url: '/api/v1/permission/del',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//管理员权限分组-列表
export function groupList() {
    return request({
        method: 'POST',
        url: '/api/v1/permission/grouplist',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//管理员权限管理-添加管理员
export function addAdmin(data) {
    return request({
        method: 'POST',
        data: data,
        url: '/api/v1/permission/add',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//管理员权限管理-编辑管理员
export function editAdmin(data) {
    return request({
        method: 'POST',
        data: data,
        url: '/api/v1/permission/edit',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// 管理员权限分组管理
export function adminGroupList(data){
    return request({
        method: 'POST',
        data: data,
        url: '/api/v1/permission/group/list',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//管理员权限分组状态修改
export function updateGroupStatus(id) {
    return request({
        method: 'POST',
        data: { id },
        url: '/api/v1/permission/group/change/status',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//管理员权限分组删除
export function deleteGroup(id) {
    return request({
        method: 'POST',
        data: { id },
        url: '/api/v1/permission/group/del',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//管理员权限分组添加
export function addGroup(data) {
    return request({
        method: 'POST',
        data: data,
        url: '/api/v1/permission/group/add',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//管理员权限分组编辑
export function editGroup(data) {
    return request({
        method: 'POST',
        data: data,
        url: '/api/v1/permission/group/edit',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
//获取权限列表
export function getPermissionList() {
    return request({
        method: 'POST',
        url: '/api/v1/permission/group/permissionList',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//获取权限
export function getAdminPermission() {
    return request({
        method: 'POST',
        url: '/api/v1/permission/get/permission',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}


// *******************************************************************************************************************




//卡密导出
export function cardExport(data) {
    return request({
        method: 'POST',
        data: data,
        url: '/api/v1/card/export',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// *******************************************************************************************************************
// 商品管理---商品列表
export function getGoodsList(params) {
    return request({
        method: 'POST',
        url: '/api/v1/goods/list',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//商品添加
export function goodsAdd(data){
    return request({
        method:'POST',
        url:'/api/v1/goods/add',
        data:data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//商品编辑
export function goodsEdit(data){
    return request({
        method:'POST',
        url:'/api/v1/goods/edit',
        data:data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//商品删除
export function goodsDelete(id){
    return request({
        method:'POST',
        url:'/api/v1/goods/del',
        data:{ id },
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//商品状态切换
export function goodsChangeStatus(id, status) {
    return request({
        method: 'POST',
        data: { id, status },
        url: '/api/v1/goods/change_status',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//商品图片上传
export function uploadGoodsImage(file) {
    const formData = new FormData();
    formData.append('image', file);
    return request({
        method: 'POST',
        url: '/api/v1/goods/up_img',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

//获取商品类别列表（商品管理专用）
export function getGoodsCategoryList() {
    return request({
        method: 'POST',
        url: '/api/v1/goods/get_category',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// *******************************************************************************************************************
// 首页数据
export function getHomeData() {
    return request({
        method: 'POST',
        url: '/api/v1/home/get_data',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// *******************************************************************************************************************
// 商品类别管理---类别列表
export function getCategoryList(data) {
    return request({
        method: 'POST',
        url: '/api/v1/category/list',
        data: data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//商品类别添加
export function categoryAdd(data){
    return request({
        method:'POST',
        url:'/api/v1/category/add',
        data:data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//商品类别编辑
export function categoryEdit(data){
    return request({
        method:'POST',
        url:'/api/v1/category/edit',
        data:data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//商品类别删除
export function categoryDelete(id){
    return request({
        method:'POST',
        url:'/api/v1/category/del',
        data:{ id },
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// *******************************************************************************************************************
// 聊天管理
// 获取在线用户列表
export function getOnlineUsers(data) {
    return request({
        method: 'POST',
        url: '/api/v1/chat/online',
        data: data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// 获取聊天消息列表
export function getChatMessages(data) {
    return request({
        method: 'POST',
        url: '/api/v1/chat/messages',
        data: data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// 发送消息（客服）
export function sendChatMessage(data) {
    return request({
        method: 'POST',
        url: '/api/v1/chat/send',
        data: data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// 上传聊天图片
export function uploadChatImage(file) {
    const formData = new FormData();
    formData.append('image', file);
    return request({
        method: 'POST',
        url: '/api/v1/chat/upload_image',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 标记消息为已读
export function markChatAsRead(data) {
    return request({
        method: 'POST',
        url: '/api/v1/chat/mark_read',
        data: data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// 获取未读消息数
export function getChatUnreadCount(data) {
    return request({
        method: 'POST',
        url: '/api/v1/chat/unread',
        data: data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
